import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileLinkPipe } from './_pipes/file-link/file-link.pipe';

@NgModule({
  declarations: [FileLinkPipe],
  imports: [CommonModule],
  exports: [FileLinkPipe],
})
export class FilelinkModule {}
